/**
 * Logo High Resolution Fix
 * Forces the header logo to load at higher resolution
 */

document.addEventListener('DOMContentLoaded', function() {
  const logo = document.querySelector('.header__logo img, .small--hide.image-element');

  if (logo && logo.src) {
    // Replace the width parameter in the URL to request a larger image
    const highResUrl = logo.src.replace(/width=\d+/, 'width=360');

    // Create a new image to preload
    const highResImg = new Image();
    highResImg.onload = function() {
      logo.src = highResUrl;
    };
    highResImg.src = highResUrl;
  }
});
